'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestStateUpdate = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Set status and operate on data
 *
 * @param {string} newStatus updated status
 * @param {Function} operator update operator to update state
 * @param {AsyncData} asyncData AsyncData record to update
 * @returns {AsyncData}
*/
var requestStateUpdate = exports.requestStateUpdate = (0, _curry2.default)(function (newStatus, operator, asyncData) {
  return asyncData.updateIn(_keyPaths.DATA, operator).setIn(_keyPaths.STATUS, newStatus);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/async-data/operators/requestStateUpdate.js
// module id = 232
// module chunks = 2 3